import { Box, useTheme } from '@mui/material'
import React from 'react'
import type { IconType } from 'react-icons'

interface IconProps {
  icon: IconType
  size?: number | string
  color?: string
  onClick?: (e: any) => void
  className?: string
  style?: React.CSSProperties
}

const Icon: React.FC<IconProps> = ({
  icon: IconComponent,
  size = 18,
  color,
  onClick,
  className,
  style,
}) => {
  const theme = useTheme()
  return (
    <Box
      component={IconComponent}
      sx={{
        cursor: 'pointer',
        fontSize: size,
        color: color || theme.palette.text.primary,
        ...style,
      }}
      className={className}
      onClick={onClick}
    />
  )
}

export default Icon
